module.exports = __webpack_public_path__ + "img/collection-engagementRingsClassic.49af098.webp";